module.exports = __webpack_public_path__ + "static/img/pc_pd_2.e496a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_2.png
// module id = UnaK
// module chunks = 0